module.exports = __webpack_public_path__ + "media/src/assets/images/campaign-industry-dots-1b34fefde3f17bd09110da1e8340825c.svg";